<script>
	import { colors } from './utils.js';

	export let theme = null;

	let style = '';

  if (theme) {
    style += ` color: ${colors[theme]['text']}; background-color: ${colors[theme]['background']};`
  }
</script>

<section style={style}>
	<div class="col-medium">
		<slot></slot>
	</div>
</section>